import React from 'react';
import * as S from './TooltipStyles';

interface TooltipProps {
  children: React.ReactNode;
  title?: string;
  content?: string;
  icon?: React.ReactElement;
}

const Tooltip: React.FC<TooltipProps> = ({ children, title, content, icon }: TooltipProps) => {
  return (
    <S.Tooltip>
      {children}

      <S.TooltipContent>
        <div className="header">
          <h6>{title}</h6>
        </div>

        <div className="content">
          {icon && <span>{icon}</span>}

          <p>{content}</p>
        </div>
      </S.TooltipContent>
    </S.Tooltip>
  );
};

export default Tooltip;
